var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSmileTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z",
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 14.75C12.1904 14.75 12.75 14.1904 12.75 13.5C12.75 12.8096 12.1904 12.25 11.5 12.25C10.8096 12.25 10.25 12.8096 10.25 13.5C10.25 14.1904 10.8096 14.75 11.5 14.75Z",
    fill: "#262626"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 14.75C21.1904 14.75 21.75 14.1904 21.75 13.5C21.75 12.8096 21.1904 12.25 20.5 12.25C19.8096 12.25 19.25 12.8096 19.25 13.5C19.25 14.1904 19.8096 14.75 20.5 14.75Z",
    fill: "#262626"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1998 19C20.6712 19.9107 19.9126 20.6667 19 21.1922C18.0874 21.7176 17.0529 21.9942 15.9998 21.9942C14.9468 21.9942 13.9122 21.7176 12.9996 21.1922C12.087 20.6667 11.3284 19.9107 10.7998 19",
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSmileTwo);
export default __webpack_public_path__ + "static/media/ic_smile_two.e4189d90d4cf2c34b364e953c4fc0913.svg";
export { ForwardRef as ReactComponent };